'use client';

import { Video } from 'lucide-react';

import { useMemo } from 'react';

import { Button } from '@/components/ui/button';

import { COPY } from '@/shared/constants/copies';

import { ConfirmationDialog } from './components/confirmation-dialog';
import { ErrorView } from './components/error-view';
import { LiveView } from './components/live-view';
import { ReviewView } from './components/review-view';
import { SavedView } from './components/saved-view';
import { UploadingView } from './components/uploading-view';
import { MAX_RECORDING_TIME } from './constants';
import { useVideoRecording } from './video-recording-provider';

export function VideoRecordingContent() {
	const { uiState, canvasRef, videoContainerRef, openCamera, isRecordingBlocked } =
		useVideoRecording();

	const content = useMemo(() => {
		switch (uiState.state) {
			case 'initial':
				return (
					<div className="space-y-2">
						<div className="flex items-center gap-2">
							<Button
								type="button"
								variant="outline"
								className="h-[44px] gap-2 border-border text-sm font-medium text-slate-700"
								onClick={() => openCamera('initial')}
								disabled={isRecordingBlocked}
							>
								<Video className="h-4 w-4" /> Start recording{' '}
								<span className="text-xs text-muted-foreground">
									{COPY.fields.videoMaxLength(MAX_RECORDING_TIME)}
								</span>
							</Button>
						</div>
					</div>
				);
			case 'camera':
			case 'recording':
				return <LiveView />;
			case 'preview':
			case 'edit':
				return <ReviewView />;
			case 'saved':
				return <SavedView />;
			case 'uploading':
				return <UploadingView />;
			case 'error':
				return <ErrorView />;
			default:
				return null;
		}
	}, [uiState.state, openCamera, isRecordingBlocked]);

	return (
		<div
			className="space-y-4"
			ref={videoContainerRef}
		>
			{content}
			<ConfirmationDialog />
			<canvas
				ref={canvasRef}
				style={{ display: 'none' }}
				width="1280"
				height="720"
			/>
		</div>
	);
}
